import type { ComponentProps } from "react";
import { BaseButton } from "src/components";

export type ExcelButtonProps = ComponentProps<typeof BaseButton>;

const ExcelButton = (props: ExcelButtonProps) => {
  const { className, ...buttonProps } = props;

  return <BaseButton {...buttonProps} className={`base-btn color-white size-small excel-button ${className || ""}`.trim()} />;
};

export default ExcelButton;
